import Layout from "../../Components/TopNav/Topnav";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  makeStyles,
  Button,
  TextField,
  CircularProgress,
  Snackbar,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import axios from "../../util/axios";
import { styled, tableCellClasses} from "@mui/material";
import { useTranslation } from "react-i18next";
import ConfirmationDialog from "../../Components/ConfirmationDialog/ConfirmationDialog";
import { DropzoneArea } from "material-ui-dropzone";
import Cookies from "js-cookie";
import moment from "moment";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import AssessmentIcon from '@mui/icons-material/Assessment';
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import axiosAws from "axios";

// Temporary notice — remove after Monday Aug 4, 2026
const JULY_REPORT_NOTICE_EXPIRES_AT = new Date("2026-08-04T23:59:59+04:00");
const isJulyReportNoticeActive = () =>
  Date.now() <= JULY_REPORT_NOTICE_EXPIRES_AT.getTime();

const useStyles = makeStyles(() => {
  return {
    root: {
      backgroundColor: "rgb(246, 246, 247)",
    },
    boxWrapper: {
      display: "grid",
      gap: 25,
      backgroundColor: "rgb(246, 246, 247)",
      height: "fit-content",
      padding: 20,
    },
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
    },
    loadingBox: {
      margin: "12% auto",
      textAlign: "center",
    },
    loading: {
      textAlign: "center",
      margin: "0 auto",
      color: "#ff2c46",
    },
  };
});

const Billing = () => {
  const classes = useStyles();
  const [clinicReportsData, setClinicReportsData] = useState([]);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontWeight: "bold",
    },
  }));

  const clinicId = Cookies.get("clinic_id");
  const clinicName = Cookies.get("clinic_name");

  const { t, i18n } = useTranslation();
  const [disputeFilesKey, setDisputeFilesKey] = useState([]);
  const [disputeNote, setDisputeNote] = useState("");
  const [reportId, setReportId] = useState(null);
  const [invoice, setInvoice] = useState({ isOpen: false });
  const [isArabic, setIsArabic] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disputeDialog, setDisputeDialog] = useState(false);
  const [acceptDialog, setAcceptDialog] = useState(false);
  const [pending, setPending] = useState(false);
  const [filesUploading, setFilesUploading] = useState(0);
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const uploadEpochRef = useRef(0);

  let align = isArabic ? "right" : "left";
  const { isOpen} = invoice;
  const onChange = (e) => {
    const { value } = e.target;
    setDisputeNote(value);
  };
  
  const onFileChange = async (filesImage1) => {
    if (!filesImage1.length) {
      return;
    }
    const file = filesImage1[filesImage1.length - 1];
    const epoch = uploadEpochRef.current;
    const ext = file.path.split(".").pop();
    const imageType = file.type;
    const form_data = new FormData();
    form_data.append("content_type", imageType);
    setFilesUploading((count) => count + 1);
    try {
      const res = await axios.post(`/admin/v1/images/s3`, form_data);
      try {
        await axiosAws.put(res.data.url, file, {
          headers: {
            "x-amz-acl": ["public-read-write"],
            "Content-Type": imageType,
          },
        });
        if (epoch === uploadEpochRef.current) {
          setDisputeFilesKey((prev) => [...prev, { ext, key: res.data.key }]);
          setUploadedFileName(file.name);
        }
      } catch (err) {
        console.log("Error while uploading file 1", err);
      }
    } catch (err) {
      console.log("Error while uploading file 2", err);
    } finally {
      setFilesUploading((count) => count - 1);
    }
  };

  const onFileDelete = () => {
    uploadEpochRef.current += 1;
    setDisputeFilesKey([]);
  };
  const getClinicReports = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/admin/v1/clinic-report/${clinicId}`);
      if (response) {
        const { data } = response.data;
        if (data) {
          setClinicReportsData(data);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const openInvoiceDialogHandler = (reportId) => {
    setDisputeFilesKey([]);
    setReportId(reportId);
    setInvoice((prevState) => ({ ...prevState, isOpen: true }));
  };
  const closeInvoiceDialogHandler = () => {
    setInvoice((prevState) => ({ ...prevState, isOpen: false }));
  };

  const handleAcceptReportDialog = (reportId) => {
    setReportId(reportId);
    setAcceptDialog(true);
  };

  const handleDownloadReport = (link, date) => {
    saveAs(link, `${clinicName}-${date}.pdf`);
  };

  const handleDownloadPaymentConfirmation = (link, date) => {
    saveAs(link, `${clinicName}-${date}.${link.split(".").pop()}`);
  };

  const handleDisputeReportDialog = (reportId) => {
    setDisputeNote("");
    setDisputeFilesKey([]);
    setDisputeDialog(true);
    setReportId(reportId);
  };

  const onInvoiceFileSave = async () => {
    try {
      setPending(true);
      const response = await axios.post(
          `/admin/v1/clinic-invoice/create`,
          {
            clinic_report_id: reportId,
            files: disputeFilesKey,
          },
      );
      if (response) {
        const {success} = response.data;
        if (success) {
          toast.success(t("invoice-uploaded"), 3000);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPending(false);
      setDisputeFilesKey([]);
      closeInvoiceDialogHandler();
    }
  };

  const handleCloseDialog = (type) => {
    if (type === "dispute") {
      setDisputeDialog(false);
    } else {
      setAcceptDialog(false);
    }
  };

  const handleAcceptReport = async () => {
    try {
      setPending(true);
      const response = await axios.post(`/admin/v1/clinic-report/${reportId}/accepted/`);
      if (response) {
        const {success} = response.data;
        if (success) {
          toast.success(t("report-accepted"), 3000);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPending(false);
      handleCloseDialog();
      await getClinicReports();
    }
  };

  const handleDisputeReport = async () => {
    try {
      setPending(true);
      const response = await axios.post(
        `/admin/v1/clinic-dispute/create/`,
        {
          text: disputeNote,
          clinic_report_id: reportId,
          files: disputeFilesKey,
        },
      );
      if (response) {
        const {success} = response.data;
        if (success) {
          toast.success(t("dispute-uploaded"), 3000);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPending(false);
      setDisputeFilesKey([]);
      handleCloseDialog("dispute");
      await getClinicReports();
    }
  };

  useEffect(() => {
    void getClinicReports();
  }, []);

  useEffect(() => {
    if (i18n.language === "ar") {
      setIsArabic(true);
    }
    if (i18n.language === "en") {
      setIsArabic(false);
    }
  }, [i18n.language, isArabic]);

  return (
    <Layout>
      {loading ? (
        <Box className={classes.loadingBox}>
          <CircularProgress className={classes.loading} />
        </Box>
      ) : (
        <Box className={classes.boxWrapper}>
          {isJulyReportNoticeActive() && (
            <Alert severity="info">{t("july-report-delay-notice")}</Alert>
          )}
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell variant="head" align={align}>
                    {t("month")}
                  </StyledTableCell>
                  <StyledTableCell variant="head" align={align}>
                    {t("report-version")}
                  </StyledTableCell>
                  <StyledTableCell variant="head" align={align}>
                    {t("download-report")}
                  </StyledTableCell>
                  <StyledTableCell variant="head" align={align}>
                    {t("accept")}
                  </StyledTableCell>
                  <StyledTableCell variant="head" align={align}>
                    {t("dispute")}
                  </StyledTableCell>
                  <StyledTableCell variant="head" align={align}>
                    {t("invoice")}
                  </StyledTableCell>
                  <StyledTableCell variant="head" align={align}>
                    {t("payment-confirmation")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clinicReportsData.length > 0 ?
                  clinicReportsData.map(
                    (
                      {
                        id,
                        accepted,
                        accepted_at,
                        date,
                        aws_url,
                        aws_url_link,
                        dispute_id,
                        dispute,
                        version,
                        invoice,
                        latest_version,
                        payment_confirmation_invoice
                      },
                      index
                    ) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align={align} component="th" scope="row">
                          {moment(date).format("MMMM YYYY")}
                        </TableCell>
                        <TableCell align={align}>{`V.${version}`}</TableCell>
                        <TableCell align={align}>
                          <Button
                              variant="contained"
                              onClick={() => handleDownloadReport(aws_url_link, date)}
                          >
                            {t("download-report")}
                          </Button>
                        </TableCell>
                        <TableCell align={align} component="th" scope="row">
                          {!dispute_id ? accepted ? (
                            `${t("accepted_on")} ${moment(accepted_at).format(
                              "DD MMMM YYYY"
                            )}`
                          ) : (
                            latest_version &&<Button
                              variant="contained"
                              disabled={!latest_version}
                              onClick={() => handleAcceptReportDialog(id)}
                            >
                              {t("accept")}
                            </Button>
                          ) : ""}
                        </TableCell>
                        <TableCell align={align}>
                          {!accepted ? dispute_id ? (
                            `${t("disputed_on")} ${moment(
                              dispute.created_at
                            ).format("DD MMMM YYYY")}`
                          ) : (
                            latest_version &&<Button
                              disabled={!latest_version}
                              onClick={() => handleDisputeReportDialog(id)}
                              variant="contained"
                            >
                              {t("dispute")}
                            </Button>
                          ) : ""}
                        </TableCell>
                        <TableCell align={align}>
                          {accepted === 1 ? (
                              <Button
                                  variant="contained"
                                  onClick={() => openInvoiceDialogHandler(id)}
                              >
                                {t("upload-invoice")}
                              </Button>
                          ) : (
                              <Button disabled
                                      variant="contained"
                                      onClick={() => openInvoiceDialogHandler(id)}
                              >
                                {t("upload-invoice")}
                              </Button>
                          )}
                        </TableCell>
                        <TableCell align={align}>
                          <Button
                              disabled={!payment_confirmation_invoice}
                              variant="contained"
                              onClick={() => handleDownloadPaymentConfirmation(payment_confirmation_invoice?.files_link, date)}
                          >
                            {t("download")}
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  ) :
                    <TableCell colSpan={6} rowSpan={3}>
                      <Box style={{textAlign: "center"}}>
                        <AssessmentIcon style={{color: '#ff2c46', fontSize: '5em'}}/>
                        <Typography>{t('no-reports')}</Typography>
                      </Box>
                    </TableCell>
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <ConfirmationDialog
        open={disputeDialog}
        handleClose={() => handleCloseDialog("dispute")}
        handleConfirm={handleDisputeReport}
        confirmationButtonText={t("Confirm")}
        cancelButtonText={t("Cancel")}
        dialogTitle={t("dispute-details")}
        pending={pending}
        enableDialog={filesUploading === 0}
      >
        <TextField
          key="disputeNotesKey"
          id="outlined-multiline-flexible"
          label={t("dispute-notes")}
          multiline
          maxRows={4}
          fullWidth
          type="text"
          onChange={onChange}
          value={disputeNote}
        />
        <div style={{ margin: "20px 0" }}></div>
        <DropzoneArea
          showPreviews={true}
          showPreviewsInDropzone={false}
          useChipsForPreview
          filesLimit={10}
          onChange={(files) => onFileChange(files)}
          onDelete={onFileDelete}
          previewGridProps={{ container: { spacing: 1, direction: "row" } }}
          previewChipProps={{ classes: { root: classes.previewChip } }}
          previewText={t("selected-files")}
          dropzoneText={filesUploading > 0 ? t("uploading") : t("drag-drop")}
        />
      </ConfirmationDialog>
      <ConfirmationDialog
        open={acceptDialog}
        handleClose={handleCloseDialog}
        handleConfirm={handleAcceptReport}
        confirmationButtonText={t("Confirm")}
        cancelButtonText={t("Cancel")}
        dialogTitle={t("accept-dialog-title")}
        pending={pending}
      >
        {t("accept-dialog-context")}
      </ConfirmationDialog>
      <ConfirmationDialog
        open={isOpen}
        handleClose={closeInvoiceDialogHandler}
        handleConfirm={onInvoiceFileSave}
        confirmationButtonText={t("submit")}
        cancelButtonText={t("Cancel")}
        dialogTitle={t("Upload-Files")}
        pending={pending}
        enableDialog={filesUploading === 0 && disputeFilesKey.length > 0}
      >
        <DropzoneArea
          filesLimit={1}
          maxFileSize={5000000}
          acceptedFiles={['application/pdf', 'image/jpeg', 'image/jpg']}
          onChange={(files) => onFileChange(files)}
          onDelete={onFileDelete}
          showPreviews={true}
          showPreviewsInDropzone={false}
          useChipsForPreview
          previewGridProps={{ container: { spacing: 1, direction: "row" } }}
          previewChipProps={{ classes: { root: classes.previewChip } }}
          previewText={t("selected-files")}
          showFileNamesInPreview={true}
          dropzoneText={filesUploading > 0 ? t("uploading") : t("drag-drop")}
        />
      </ConfirmationDialog>
      <Snackbar
        open={!!uploadedFileName}
        autoHideDuration={6000}
        onClose={() => setUploadedFileName(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={() => setUploadedFileName(null)} severity="success">
          {t("file-uploaded", { fileName: uploadedFileName })}
        </Alert>
      </Snackbar>
    </Layout>
  );
};

export default Billing;
